import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetTheonDutyRetrieveActions,
  setTheOndutyEditAction,
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import "../../../StyleSheet/MainComponent/LeavePermission/LeavePermission.scss";
import { data } from "jquery";
const OnDutyEdit = (props) => {
  const { currentPage, setShow, show, EditId, selectVal, data  , white_collar , to_date , from_date , search} = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const [descpErr, setdeserr] = useState("");
  const initialState = {
    from_date: "",
    to_date: "",
    continue_leave: "",
    status: "",
    notes: "",
    applied_date: "",
    user_id: "",
    address: "",
    certificate_id: "",
    client_id: "",
    user_name: "",
    description: "",
  };
  const [Data, setDatas] = useState(initialState);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  useEffect(() => {
    dispatch(SetTheonDutyRetrieveActions({ EditId }));
  }, []);
  useEffect(() => {
    // console.log(state.onDutyRetrieveCall.OndutyDataRetrieve, "datas");
    if (state.onDutyRetrieveCall.OndutyDataRetrieve.id != undefined) {
      const dateString =
        state.onDutyRetrieveCall.OndutyDataRetrieve.applied_date;
      const dateObject = new Date(dateString);
      const hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      const amOrPm = hours >= 12 ? "PM" : "AM";
      const twelveHourFormat = hours % 12 || 12;
      const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

      setDatas({
        ...Data,
        address: state.onDutyRetrieveCall.OndutyDataRetrieve.place_id != null ?state.onDutyRetrieveCall.OndutyDataRetrieve.place_id.address :"",

        status: state.onDutyRetrieveCall.OndutyDataRetrieve.status,
        from_date: state.onDutyRetrieveCall.OndutyDataRetrieve.from_time,
        to_date: state.onDutyRetrieveCall.OndutyDataRetrieve.to_time,
        notes: state.onDutyRetrieveCall.OndutyDataRetrieve.purpose,
        user_name:
          state.onDutyRetrieveCall.OndutyDataRetrieve.user_id.first_name,
        client_id:
          state.onDutyRetrieveCall.OndutyDataRetrieve.place_id != null ? state.onDutyRetrieveCall.OndutyDataRetrieve.place_id.client_name :"",
        description:
          state.onDutyRetrieveCall.OndutyDataRetrieve.reason_for_decline,
        // applied_date:
        // state.onDutyRetrieveCall.OndutyDataRetrieve.applied_date.slice(
        // 0,
        // 10
        // ) +
        // "  " +
        // formattedTime,
      });
    }
  }, [state.onDutyRetrieveCall.OndutyDataRetrieve]);
  const HandleChanges = (e) => {
    setDatas({
      ...Data,
      status: e.target.value,
    });
  };
  const HandleDecriptions = (e) => {
    setDatas({
      ...Data,
      description: e.target.value,
    });
    setdeserr("");
  };

  const handleClose = () => {
    setShow(false);
  };
  const HandleClick = () => {
    const payload = {
      status: Data.status.toLowerCase(),
     // description: Data.description,
     description:
     Data.status.toLowerCase() == "decline" ? Data.description : "",
      EditId: EditId,
      currentPage: currentPage,
      selectVal: selectVal,
      data: data,
      white_collar:white_collar,
      // month: Datestate.month,
      // year: Datestate.year,

      from_date:from_date,
      to_date:to_date,
      search:search
    };


    dispatch(setTheOndutyEditAction(payload, props.setShow()));
  };
  const Options = [
    {
      id: 1,
      Status: "Approved",
    },
    {
      id: 2,
      Status: "Decline",
    },
    {
      id: 3,
      Status: "Pending",
    },
  ];
  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>On Duty </span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyUserCRUD">
                      <div className="row">
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.user_name}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Purpose
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="first_name"
                            value={Data.notes}
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Client name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.client_id}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Address
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="name"
                            value={Data.address}
                            readOnly
                          />
                        </div>
                     
                        <div className="col-sm-3">
                          <div className="row">
                            <div
                              className="row"
                              style={{ marginLeft: "5px", marginTop: "15px" }}
                            >
                              <div className="col">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  From Time
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="name"
                                  value={Data.from_date}
                                  readOnly
                                />
                              </div>
                              <div className="col">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  To Time
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="name"
                                  value={Data.to_date}
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Status
                          </label>
                          <select
                            class="form-select form-select-lg col-12"
                            aria-label=".form-select-lg example"
                            onChange={HandleChanges}
                            /// value={Data.status}
                          >
                            {Options.map((item) => (
                              <option
                                selected={
                                  Data.status.toLowerCase() ==
                                  item.Status.toLowerCase()
                                }
                                value={item.Status}
                              >
                                {item.Status}
                              </option>
                            ))}
                          </select>
                        </div>
                        {Data.status.toLowerCase() == "decline" ? (
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Reason for decline
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              autocomplete="off"
                              name="description"
                              value={Data.description}
                              onChange={HandleDecriptions}
                            />
                            <p style={{ color: "red" }}>{descpErr}</p>
                          </div>
                        ) : null}
                      </div>

                   
                    </div>

                    <div className="UserButtons">
                      <button
                        class="btn  SaveBtn"
                        type="submit"
                        onClick={(e) => {
                          HandleClick(e);
                        }}
                        disabled={
                          state.onDutyRetrieveCall.OndutyDataRetrieve
                            .status == Data.status.toLowerCase()
                        }

                      >
                        Submit
                      </button>
                      <button
                        class="btn CancelBtn"
                        onClick={(e) => handleClose(e)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnDutyEdit;
